import { render } from "./VersionHistory.vue?vue&type=template&id=5b90782b"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__